/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Not_A_MemberInputs */

const th_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บุคคลนี้ไม่ใช่สมาชิก`)
};

const en_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That person is not a member.`)
};

const ja_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この方はメンバーではありません。`)
};

const zh_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此人不是成员。`)
};

const es_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa persona no es miembro.`)
};

const pt_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa pessoa não é membro.`)
};

const id_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orang itu bukan anggota.`)
};

const fr_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette personne n’est pas membre.`)
};

const tl_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi miyembro ang taong iyon.`)
};

const vi_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người đó không phải thành viên.`)
};

const ko_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그분은 구성원이 아닙니다.`)
};

const de_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Person ist kein Mitglied.`)
};

const ru_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот человек не является участником.`)
};

const tr_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O kişi üye değil.`)
};

const it_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quella persona non è un membro.`)
};

const pl_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta osoba nie jest członkiem.`)
};

const uk_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ця особа не є учасником.`)
};

const hi_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह व्यक्ति सदस्य नहीं है।`)
};

const ar_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذلك الشخص ليس عضوًا.`)
};

const ms_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orang itu bukan ahli.`)
};

const bn_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই ব্যক্তি সদস্য নন।`)
};

const zh_tw2_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那個人不是成員。`)
};

const zh_hk2_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那個人不是成員。`)
};

const ur_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ شخص رکن نہیں۔`)
};

const fa_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آن شخص عضو نیست.`)
};

const sw_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mtu huyo si mwanachama.`)
};

const nl_err_not_a_member = /** @type {(inputs: Err_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die persoon is geen lid.`)
};

/**
* | output |
* | --- |
* | "That person is not a member." |
*
* @param {Err_Not_A_MemberInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_not_a_member = /** @type {((inputs?: Err_Not_A_MemberInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_A_MemberInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_not_a_member(inputs)
	if (locale === "ja") return ja_err_not_a_member(inputs)
	if (locale === "zh") return zh_err_not_a_member(inputs)
	if (locale === "es") return es_err_not_a_member(inputs)
	if (locale === "pt") return pt_err_not_a_member(inputs)
	if (locale === "id") return id_err_not_a_member(inputs)
	if (locale === "fr") return fr_err_not_a_member(inputs)
	if (locale === "tl") return tl_err_not_a_member(inputs)
	if (locale === "vi") return vi_err_not_a_member(inputs)
	if (locale === "ko") return ko_err_not_a_member(inputs)
	if (locale === "de") return de_err_not_a_member(inputs)
	if (locale === "ru") return ru_err_not_a_member(inputs)
	if (locale === "tr") return tr_err_not_a_member(inputs)
	if (locale === "it") return it_err_not_a_member(inputs)
	if (locale === "pl") return pl_err_not_a_member(inputs)
	if (locale === "uk") return uk_err_not_a_member(inputs)
	if (locale === "hi") return hi_err_not_a_member(inputs)
	if (locale === "ar") return ar_err_not_a_member(inputs)
	if (locale === "ms") return ms_err_not_a_member(inputs)
	if (locale === "bn") return bn_err_not_a_member(inputs)
	if (locale === "zh-TW") return zh_tw2_err_not_a_member(inputs)
	if (locale === "zh-HK") return zh_hk2_err_not_a_member(inputs)
	if (locale === "ur") return ur_err_not_a_member(inputs)
	if (locale === "fa") return fa_err_not_a_member(inputs)
	if (locale === "sw") return sw_err_not_a_member(inputs)
	if (locale === "nl") return nl_err_not_a_member(inputs)
	return en_err_not_a_member(inputs)
});